module.exports = __webpack_public_path__ + "static/media/QR-donaciones-1.a4543acd.jpg";